import type { IconSvgObject } from './types';

const ChevronsLeftIcon: IconSvgObject = [
  ["path", { d: "M11 7L6 12L11 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 7L13 12L18 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsLeftIcon;
